var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconUserLogout = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-400.079 -604.67)" },
                React.createElement("g", { transform: "translate(403.62 606)" },
                    React.createElement("g", { transform: "translate(0 0)" },
                        React.createElement("line", { x1: "-1.5", y1: "23.9", x2: "15.3", y2: "23.9" }),
                        React.createElement("line", { x1: "15.3", y1: "3.5", x2: "15.3", y2: "23.9" }),
                        React.createElement("line", { x1: "6", y1: "6", x2: "15.3", y2: "3.5" }),
                        React.createElement("line", { x1: "6", y1: "6", x2: "6", y2: "23.9" })),
                    React.createElement("g", { transform: "translate(15.023 2.554)" },
                        React.createElement("line", { x1: "0.9", y1: "3.5", x2: "5.9", y2: "3.5" }),
                        React.createElement("line", { x1: "5.9", y1: "21.3", x2: "5.9", y2: "3.5" }),
                        React.createElement("line", { x1: "9.5", y1: "21.3", x2: "5.9", y2: "21.3" }))),
                React.createElement("path", { strokeLinejoin: "round", d: "M405.4,616.9l-3.3,3.3l3.3,3.3" }),
                React.createElement("path", { strokeLinejoin: "round", d: "M402,620.2h10.2" })))));
});
export default IconUserLogout;
//# sourceMappingURL=IconUserLogout.js.map